export default (placa) => {
  return (
    /^([A-Za-z]{3})+([-])+([0-9]{1})+([a-jA-J]{1})+([0-9]{2})$/.test(placa) || 
    /^([A-Za-z]{3})+([-])+([0-9]{4})$/.test(placa) ||
    /^[a-zA-Z]{3}[0-9]{4}$/.test(placa) ||
    /^[a-zA-Z]{3}[0-9]{1}[a-zA-Z]{1}[0-9]{2}$/.test(placa) ||
    /^[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}[0-9]{1}$/.test(placa)
  )
}